// Frontend API client. Talks to the Netlify functions under /api/*.

import type { AnalyseResult, PortfolioEntry, Screen } from './types'

export interface FundSummary {
  ticker: string
  name: string
  isin: string
}

async function parseError(res: Response): Promise<string> {
  try {
    const data = await res.json()
    if (data && typeof data.error === 'string') return data.error
  } catch {
    /* fall through */
  }
  return `Request failed (${res.status})`
}

export async function analysePortfolio(
  portfolio: PortfolioEntry[],
  screens: Screen[],
): Promise<AnalyseResult> {
  const res = await fetch('/api/analyse', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ portfolio, screens }),
  })
  if (!res.ok) throw new Error(await parseError(res))
  return (await res.json()) as AnalyseResult
}

export async function fetchFunds(): Promise<FundSummary[]> {
  const res = await fetch('/api/funds')
  if (!res.ok) throw new Error(await parseError(res))
  const data = (await res.json()) as { funds: FundSummary[] }
  return data.funds
}
